import { CheckCircleIcon } from 'icons/outline';
import { Link } from 'components/Link';
import { ApplicationsDropdown } from 'features/ContactSidebar/ApplicationsDropdown';
import { ContactSidebarContext } from 'features/ContactSidebar/ContactSidebarContext';
import { useContext } from 'react';

export const ContactSidebarHeader = () => {
  const ctx = useContext(ContactSidebarContext);

  const { lastJobApplication } = ctx;

  if (!lastJobApplication) {
    return null;
  }

  return (
    <header className="mb-4 pb-5 flex flex-col gap-2 text-sm border-b border-neutral-light text-neutral-ink-blue">
      <p className="flex items-center justify-start gap-2">
        <CheckCircleIcon className="w-4 h-4 text-tertiary-green-600" />
        <strong>Applied on:</strong>{' '}
        <span className="text-neutral-dark">{lastJobApplication.formattedAppliedAt()}</span>
      </p>
      <p>
        <strong>
          Role:{' '}
          <Link
            href={lastJobApplication.jobListingUrl()}
            className="underline underline-offset-2 text-primary-pure-blue"
          >
            {lastJobApplication.jobListingTitle()}
          </Link>
        </strong>
      </p>
      <p>
        <strong>Location:</strong>{' '}
        <span className="text-neutral-dark">{lastJobApplication.firstAddress()}</span>
      </p>

      <ApplicationsDropdown />
    </header>
  );
};

ContactSidebarHeader.displayName = 'ContactSidebarHeader';
